import { FC, useState } from 'react';
import s from './StepHeader.module.css';
import IconFullRightArrow from '../../../../shared/ui/icons/IconFullRightArrow';

interface StepHeaderProps {
    step: number;
    setStep: (step: number) => void;
    totalSteps: number;
    tab?: string;
    handleSwitch: (tab: string) => void;
}

const StepHeader: FC<StepHeaderProps> = ({ step, setStep, totalSteps, tab, handleSwitch }) => {
    const handleBack = () => {
        setStep(step - 1);
        if (step === 2 && tab === 'reset-password') {
            handleSwitch('signin');
        }
    };
    return (
        <div className={s.container}>
            {step > 1 && (
                <button className={s.back_button} onClick={handleBack}>
                    <IconFullRightArrow /> Back
                </button>
            )}
            {/* { step > 1 && (
                <div className={s.step_text}>
                    Step {step} of {totalSteps}
                </div>
            )} */}
        </div>
    );
};
export default StepHeader;
